import { Icon } from '@amumin/ui-core';

import styles from '../platform/beheer.module.css';
import { appText, context } from '../state/session.js';

/**
 * Rustige banner als AMUMIN Beheer het actieve huishouden pauzeerde (0035, DESIGN.md §8.BH.3):
 * alles blijft zichtbaar, wijzigen geeft 423 household_paused. Geen alarmkleur, geen schuld.
 */
export function PausedBanner() {
  const ctx = context.value;
  const active = ctx?.households.find((h) => h.id === ctx.active_household_id);
  if (!active?.paused) return null;
  const p = appText.value.beheer.paused;
  return (
    <div class={styles.pausedBanner} role="status" data-name="paused-banner">
      <span class={styles.pausedIcon} aria-hidden="true">
        <Icon id="eye" size={20} />
      </span>
      <div>
        <strong>{p.title}</strong>
        <p>{p.body}</p>
      </div>
    </div>
  );
}
